import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16414b3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plugins" }
const _hoisted_2 = { class: "plugins__container container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "plugins__title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "plugins__title--h2" }, " Plugins "),
  /*#__PURE__*/_createElementVNode("p", { class: "plugins__title--p" }, " para aumentar la productividad ")
], -1))
const _hoisted_4 = {
  id: "modulos",
  class: "modulos plugins__slider"
}
const _hoisted_5 = { class: "modulos__current" }
const _hoisted_6 = { class: "modulos__info" }
const _hoisted_7 = { class: "modulos__info--h2" }
const _hoisted_8 = { class: "modulos__info--p" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-up-line" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "modulos__featured" }
const _hoisted_15 = { class: "modulos__featured--box" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "modulos__container" }
const _hoisted_19 = { class: "modulos__info" }
const _hoisted_20 = { class: "modulos__title" }
const _hoisted_21 = { class: "modulos__featured--item" }
const _hoisted_22 = ["src"]

import Plugins from '@/entities/Plugins';
import PluginsService from '@/services/PluginsService';
import { computed, onMounted, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PluginSection',
  setup(__props) {

const pluginsService: Ref<PluginsService> = ref(new PluginsService())
const plugins: Ref<Plugins[]> = ref([])
let selectedIndex: Ref<number> = ref(0)
const isMounted = ref(false)

onMounted(async () => {
  await getPlugins()
  getItemByIndex(0)
  isMounted.value = true
})

const getPlugins = async () => {
  plugins.value = await pluginsService.value.getFilteredPlugins(false)
}

const getItemByIndex = (index: number): Plugins | undefined => {
  if (index >= 0 && index < plugins.value.length) {
    // Reorganizar el array para que el item clickeado quede al inicio
    const clickedPlugin = plugins.value[index]
    const beforeClicked = plugins.value.slice(0, index)
    const afterClicked = plugins.value.slice(index + 1)
    
    // Nuevo orden: item clickeado al inicio, luego los que estaban después, luego los que estaban antes
    plugins.value = [clickedPlugin, ...afterClicked, ...beforeClicked]
    
    // El índice seleccionado ahora es siempre 0 (el primero)
    selectedIndex.value = 0
    
    // Hacer scroll al inicio del slider
    const slider = document.querySelector('.modulos__slider') as Element
    if (slider) {
      setTimeout(() => {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }, 10)
    }
    
    return plugins.value[0]
  }
  return undefined
}

const selectedItem = computed((): Plugins => {
  if (isMounted.value && plugins.value.length > 0) {
    return plugins.value[selectedIndex.value]
  }
  return {} as Plugins
})

const incrementIndex = () => {
  if (plugins.value.length > 0) {
    // Mover el primer elemento al final
    const firstPlugin = plugins.value[0]
    plugins.value = [...plugins.value.slice(1), firstPlugin]
    
    // El índice siempre es 0
    selectedIndex.value = 0
    
    // Hacer scroll al inicio
    const slider = document.querySelector('.modulos__slider') as Element
    if (slider) {
      setTimeout(() => {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }, 10)
    }
  }
};

const decrementIndex = () => {
  if (plugins.value.length > 0) {
    // Mover el último elemento al inicio
    const lastPlugin = plugins.value[plugins.value.length - 1]
    plugins.value = [lastPlugin, ...plugins.value.slice(0, -1)]
    
    // El índice siempre es 0
    selectedIndex.value = 0
    
    // Hacer scroll al inicio
    const slider = document.querySelector('.modulos__slider') as Element
    if (slider) {
      setTimeout(() => {
        slider.scrollTo({ left: 0, behavior: 'smooth' })
      }, 10)
    }
  }
};


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(selectedItem.value.name), 1),
            _createElementVNode("p", _hoisted_8, _toDisplayString(selectedItem.value.short_descript), 1),
            _createVNode(_component_RouterLink, {
              class: "modulos__info--a",
              to: { name: 'plugins', params: { id: selectedItem.value.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(selectedItem.value.price) + " UF/Mes", 1),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", { class: "modulos__arrows" }, [
            _createElementVNode("button", {
              onClick: decrementIndex,
              class: "modulos__arrows--left modulos__arrows--button"
            }, _hoisted_11),
            _createElementVNode("button", {
              onClick: incrementIndex,
              class: "modulos__arrows--right modulos__arrows--button"
            }, _hoisted_13)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              class: "modulos__featured--img",
              src: 'assets/img/plugins/' + selectedItem.value.image,
              alt: "featured image slider"
            }, null, 8, _hoisted_16)
          ])
        ]),
        _createVNode(_TransitionGroup, {
          name: "plugin-carousel",
          tag: "div",
          class: "modulos__slider"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plugins.value, (plugin, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: plugin.id,
                class: _normalizeClass(['modulos__item', (index === _unref(selectedIndex)) ? 'modulos__item--active' : '']),
                onClick: ($event: any) => (getItemByIndex(index))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h3", _hoisted_20, _toDisplayString(plugin.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("img", {
                      class: "modulos__img--item",
                      src: 'assets/img/plugins/' + plugin.image,
                      alt: "featured imagen item slider"
                    }, null, 8, _hoisted_22)
                  ])
                ])
              ], 10, _hoisted_17))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})